import { Text } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import ActivationKitModal from '../../molecules/activation-kit-modal'
import t from './strings'
import {
  KitModalText,
  MobileSeparator,
  OrientationTitleContainer,
  PageContainer,
  PageTitle,
} from './styles'
import OrientationType from './orientation-type'
import { OrientationList } from './constants'

type OrientationTypeSelectorProps = {
  setSupplyAcquisitionMethod?: any
  trackDropshippingEvent?: (string, data?) => Promise<any>
}

export const OrientationTypeSelector: React.FC<OrientationTypeSelectorProps> = props => {
  const { setSupplyAcquisitionMethod, trackDropshippingEvent } = props

  const [isShowingModal, setShowingModal] = React.useState(false)

  React.useEffect(() => {
    trackDropshippingEvent('DA_dxds_selection_page', { version: 2 })
  }, [])

  const toggleModal = e => {
    e.stopPropagation()

    setShowingModal(!isShowingModal)
  }

  return (
    <PageContainer>
      {isShowingModal && (
        <ActivationKitModal
          onClose={e => {
            toggleModal(e)
          }}
        />
      )}

      <OrientationTitleContainer>
        <PageTitle>{t.h1()}</PageTitle>
        <KitModalText styles={Text.Styles.ContentAction} onClick={toggleModal}>
          {t.kitModalButton()}
        </KitModalText>
      </OrientationTitleContainer>

      <MobileSeparator />

      {OrientationList.map((orientation, index) => (
        <React.Fragment key={index}>
          <OrientationType
            title={orientation.title}
            buttonName={orientation.buttonName}
            trackDropshippingEvent={trackDropshippingEvent}
            eventName={orientation.eventName}
            setSupplyAcquisitionMethod={setSupplyAcquisitionMethod}
            supplyAcquisitionMethod={orientation.supplyAcquisitionMethod}
          />
          <MobileSeparator />
        </React.Fragment>
      ))}
    </PageContainer>
  )
}

OrientationTypeSelector.defaultProps = {
  setSupplyAcquisitionMethod: console.log,
  trackDropshippingEvent: (aString: string) =>
    Promise.resolve(console.log(aString)),
}

const mapDispatchToProps = {
  trackDropshippingEvent: events.trackDropshippingEvent,
}

export const DisconnectedOrientationTypeSelector = OrientationTypeSelector

export default connect(null, mapDispatchToProps)(OrientationTypeSelector)
